export function getYouTubeEmbed(url: any) {
  if (!url || typeof url !== 'string') {
    console.error('URL inválida:', url);
    return null;
  }
  // Padrões de URL do YouTube
  const patterns = [
    // Formato padrão: https://www.youtube.com/watch?v=ID
    /youtu(?:be\.com|\.be)\/(?:watch\?v=|embed\/|v\/|shorts\/)?([A-Za-z0-9_-]{11})/,
    // Formato live: https://www.youtube.com/live/ID
    /youtube\.com\/live\/([A-Za-z0-9_-]{11})/,
    // Formato embed: https://www.youtube.com/embed/ID
    /youtube\.com\/embed\/([A-Za-z0-9_-]{11})/,
    // Formato curto: youtu.be/ID
    /youtu\.be\/([A-Za-z0-9_-]{11})/,
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return `https://www.youtube.com/embed/${match[1]}?playlist=${match[1]}&loop=1&rel=0&autoplay=1&controls=0&showinfo=0&mute=1`;
    }
  }

  console.error('Nenhum padrão de URL do YouTube encontrado:', url);
  return null;
}
